// src/pages/msp-inventory/components/reports/ClickableSkuCell.jsx
import React from "react";

// Every report table renders SKU/title through this — clicking navigates to
// the universal SKU detail drill-down, per "make sure everything is clickable".
const ClickableSkuCell = ({ item, onOpen }) => (
    <button
        onClick={() => onOpen(item.catalog_item_id)}
        className="relative flex items-center gap-2 text-left hover:bg-teal-50 rounded-lg px-1.5 py-1 -mx-1.5 transition group"
    >
        {item.image_url ? (
            <>
                <img
                    src={item.image_url}
                    alt=""
                    className="w-8 h-8 object-contain rounded flex-shrink-0"
                />
                {/* Enlarged preview shown on hover */}
                <span
                    className="pointer-events-none absolute left-0 top-full mt-1 z-50 opacity-0 scale-95 origin-top-left
                               group-hover:opacity-100 group-hover:scale-100 transition duration-150 ease-out"
                >
                    <img
                        src={item.image_url}
                        alt=""
                        className="w-40 h-40 object-contain rounded-lg border border-gray-200 bg-white shadow-lg p-1"
                    />
                </span>
            </>
        ) : (
            <span className="w-8 h-8 flex items-center justify-center text-lg flex-shrink-0">📦</span>
        )}
        <span className="min-w-0">
            <p className="text-xs font-semibold text-gray-800 group-hover:text-teal-700 truncate max-w-[220px]">{item.title || item.sku}</p>
            <p className="text-[10px] text-gray-400 font-mono">{item.sku}</p>
        </span>
    </button>
);

export default ClickableSkuCell;